import React, { useEffect, useState } from "react";
import { StyledWrapper } from "../../dashboard/style";
// import { adminStatisticsData } from "../../dashboard/constant";
import { StyledOrdersContainer } from "../../../components/orders-dashboard/style";
import OrderTableHeader from "../../../components/common/table/OrderTableHeader";
import { StatusBadge, StyledBoxTextInner, StyledTypographyText } from "../../virtual-locker/style";
import { Box, TablePagination } from "@mui/material";
import CustomButton from "../../../components/common/button/CustomButton";
import theme from "../../../theme";
import CreateShipmentSvg from "../../../assets/Icons/Create";
import ShippingPartners from "../../../components/modals/shipping-partners/ShippingPartners";
import { useDispatch, useSelector } from "react-redux";
import { SETTING_COUPON_DELETE, SETTING_COUPON_LIST, SETTING_DECLARATIONS_DELETE, SETTING_DECLARATIONS_LIST, SETTING_LOCKER_DELETE, SETTING_LOCKER_LIST, SETTING_NOTIFICATION_DELETE, SETTING_NOTIFICATION_LIST, SHIPPING_PARTNER_DELETE, SHIPPING_PARTNER_LIST, SHOPPER_PRICE_DELETE, SHOPPER_PRICE_LIST } from "../../../actions/admin/customer-actions";
import Confirmation from "../../../components/modals/confirmation-modal/Confirmation";
import SettingCoupon from "../../../components/modals/setting-coupon/SettingCoupon";
import SettingDeclarations from "../../../components/modals/setting-declarations/SettingDeclarations";
import CommonTable from "../../../components/common/table/CommonTable";
import moment from "moment/moment";
import SettingNotification from "../../../components/modals/setting-notification/SettingNotification";
import DotIcon from '../../../assets/svg/dot-icon.svg';
import { formatName } from "../../../utils/common";
import SettingLocker from "../../../components/modals/setting-locker/SettingLocker";
import SettingShopperPrice from "../../../components/modals/setting-shopper-price/SettingShopperPrice";
import InvoiceSettingsPanel from "./InvoiceSettingsPanel";
import Loader from "../../../components/common/loader/Loader";


const AdminSettings = () => {
  const [editRecord, setEditRecord] = useState(0);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const [shippingPartnerModel, setShippingPartnerModel] = useState(false);
  const [couponModel, setCouponModel] = useState(false);
  const [declarationsModel, setDeclarationsModel] = useState(false);
  const [lockerItemsModel, setLockerItemsModel] = useState(false);
  const [shopperPriceItemsModel, setShopperPriceItemsModel] = useState(false);
  const [notificationModel, setNotificationModel] = useState(false);
  // const [coupenModel, setCoupenModel] = useState(false);
  const capitalizeFirst = (str = "") =>
    str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  
  const shippingPartnercolumns =[
  { label: "Name", key: "name" },
  { label: "Status", key: "status" },
  { label: "Last Updated", key: "updatedAt" },
  { label: "Region", key: "region" },
  { label: "Type", key: "type" },
  { label: "Actions", key: "actions" },
  ];
 
const couponColumns = [
  { label: "Code", key: "code" },
  { label: "Discount", key: "discount_value" },
  { label: "Valid Until", key: "valid_until" },
  { label: "Status", key: "status" }, 
  { label: "Actions", key: "actions" },
];
const declarationsColumns = [
  { label: "Name", key: "name" },
  { label: "Type", key: "type" },
  { label: "Countries", key: "countries" },
  { label: "Status", key: "status" }, 
  { label: "Actions", key: "actions" },
  ];

   const notificationColumns = [
  { label: "Name", key: "name" },
  { label: "Type", key: "type" },
  { label: "Last Updated", key: "lastDate" },
  { label: "Status", key: "status" }, 
  { label: "Actions", key: "actions" },
];

  const lockerColumns = [
  { label: "Title", key: "name" },
  { label: "Version", key: "version" },
  { label: "Last Updated", key: "updatedAt" },
  { label: "Status", key: "status" }, 
  { label: "Actions", key: "actions" },
];

  const shopperPricingColumns = [
  { label: "Name", key: "name" },
  { label: "Price", key: "price" },
  { label: "Region", key: "region" },
  { label: "Status", key: "status" }, 
  { label: "Actions", key: "actions" },
];
  const tabLabels = ["Invoice settings", "Shipping Partners", "Coupons", "Declarations", "Locker terms", "Notification templates", "Shopper pricing"];
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const { shippingPartner, coupons, declarations,notification,lockerData,shopperPricing, isLoading } = useSelector((state) => state?.settingData);
  const statusColors = {
    true: { background: "#00C046" }, // green
    false: { background: "#FF8500" }, // yellow
  };

  const sellingPartnerList =
    shippingPartner?.data?.map((item, index) => {
      return {
        number: index + 1,
        id: item.id,
        name: item.name,
        discount_value: item.discount_value,
        discount_type: item.discount_type,
        valid_from: moment(item.valid_from).format("DD MMM YYYY"),
        valid_until: item.valid_until,
        region: item.region,
        is_active: item.is_active,
        type: item.type,
        originalStatus: item.status,
        updatedAt:moment(item.last_updatedAt).format("DD MMM YYYY"),
        status: (
          <span
            style={{
              background: statusColors[item.is_active]?.background,
              fontWeight: "500px",
              display: "inline-flex",
              color: "white",
              padding: "2px 8px 2px 6px",
              borderRadius: "16px",
              fontSize: "12px",
              textAlign: "center",
              alignContent:"center",
              alignItems:"center",
              gap:4
            }}
          >
            <img src={DotIcon} alt="" />{item.is_active? 'Active':'Disable'}
          </span>
        ),
      }
    }) || [];

  const declarationList =
    declarations?.data?.map((item) => {
      return {
        id: item.id,
        name: item.name,
        type: item.type,
        countries: item.countries,
        status: (
          <StatusBadge status={item.status}>
            <img src={DotIcon} alt="" />{capitalizeFirst(item.status)}
          </StatusBadge>
        ),
        originalStatus: item.status
    }
    }) || [];

    const lockerList =
    lockerData?.data?.map((item) => {
      return {
        id: item.id,
        name: item.name,
        version:item?.version,
        type: item.type,
        terms: item.terms,
        updatedAt:moment(item.last_updatedAt).format("DD MMM YYYY"),
        countries: item.countries,
        status: (
          <StatusBadge status={item.status}>
            <img src={DotIcon} alt="" />{capitalizeFirst(item.status)}
          </StatusBadge>
        ),
        originalStatus: item.status
        
    }
    }) || [];

    const shopperPriceList =
    shopperPricing?.data?.map((item) => {
      return {
        id: item?.id,
        name: item?.name,
        price: item?.price,
        region:item?.region,
        status: (
          <StatusBadge status={item?.status}>
            <img src={DotIcon} alt="" />{capitalizeFirst(item?.status)}
          </StatusBadge>
        ),
        originalStatus: item?.status
        
    }
    }) || [];

  const notificationList =
    notification?.data?.map((item) => {
      return {
        id: item?.id,
        name: item?.name,
        type: formatName(item?.type),
        lastDate: item.last_updatedAt
        ? moment(item.last_updatedAt).format("DD MMM YYYY")
        : "-",
        originalStatus: item?.status,
        status: (
          <StatusBadge status={item?.status}>
            <img src={DotIcon} alt="" />{capitalizeFirst(item?.status)}
          </StatusBadge>
        ),
        content: item?.content,
      };
    }) || [];
  // statusCard: <StatusBadge status={item.status}>{item.status ? 'Active' : 'Disable'}</StatusBadge>,
  
  const couponList =
    coupons?.data?.map((item, index) => {
      return {
        number: index + 1,
        id: item.id,
        code: item.code,
        discount_value:  item.discount_value,
        valid_until: item.valid_until
        ? moment(item.valid_until).format("DD MMM YYYY")
        : "-",
        valid_from: item.valid_from
        ? moment(item.valid_from).format("DD MMM YYYY")
        : "-",
        discount_type: item.discount_type,
        max_amount: item.max_amount,
        originalStatus: item.status,
        status: (
          <StatusBadge status={item.status}>
             <img src={DotIcon} alt="" />{capitalizeFirst(item.status)}
          </StatusBadge>
        ),
      };
    }) || [];

  const addRecordModelHideShow = () => {
    switch (selectedTab) {
      case 0:
        break;
      case 1:
        setShippingPartnerModel(!shippingPartnerModel);
        break;
      case 2:
        setCouponModel(!couponModel);
        break;
      case 3:
        setDeclarationsModel(!declarationsModel);
        break;
      case 4:
        setLockerItemsModel(!lockerItemsModel);
        break;
      case 5:
        setNotificationModel(!notificationModel);
        break;

      case 6:
        setShopperPriceItemsModel(!shopperPriceItemsModel);
        break;

      default:
        break;
    }
  };

  const deleteRecodConfirm = () => {
    switch (selectedTab) {
      case 0:
        break;
      case 1:
        dispatch({
          type: SHIPPING_PARTNER_DELETE,
          payload: {
            id: editRecord?.id,
            onSuccess: () => {
              getShippingPartnerList();
              setIsEditMode(false);
              // editRecord({});
              setDeleteConfirmOpen(false);
            },
          },
        });
        break;
      case 2:
        dispatch({
          type: SETTING_COUPON_DELETE,
          payload: {
            id: editRecord?.id,
            onSuccess: () => {
              getSettingCouponList();
              setIsEditMode(false);
              // editRecord({});
              setDeleteConfirmOpen(false);
            },
          },
        });
        break;
      case 3:
        dispatch({
          type: SETTING_DECLARATIONS_DELETE,
          payload: {
            id: editRecord?.id,
            onSuccess: () => {
              getSettingDeclarationList();
              setIsEditMode(false);
              // editRecord({});
              setDeleteConfirmOpen(false);
            },
          },
        });
        break;
      case 4:
        dispatch({
          type: SETTING_LOCKER_DELETE,
          payload: {
            id: editRecord?.id,
            onSuccess: () => {
              getSettingLockerList();
              setIsEditMode(false);
              // editRecord({});
              setDeleteConfirmOpen(false);
            },
          },
        });
        break;
      case 5:
        dispatch({
          type: SETTING_NOTIFICATION_DELETE,
          payload: {
            id: editRecord?.id,
            onSuccess: () => {
              getSettingNotificationList();
              setIsEditMode(false);
              // editRecord({});
              setDeleteConfirmOpen(false);
            },
          },
        });
        break;

      case 6:
        dispatch({
          type: SHOPPER_PRICE_DELETE,
          payload: {
            id: editRecord?.id,
            onSuccess: () => {
              getShopperPriceList();
              setIsEditMode(false);
              // editRecord({});
              setDeleteConfirmOpen(false);
            },
          },
        });
        break;
    
      default:
        break;
    }
  };

  const getShippingPartnerList = React.useCallback(
    (values) => {
      dispatch({
        type: SHIPPING_PARTNER_LIST,
        payload: {
          page,
          limit: rowsPerPage,
        },
      });
    },
    [dispatch, rowsPerPage, page]
  );
  const getSettingCouponList = React.useCallback(
    (values) => {
      dispatch({
        type: SETTING_COUPON_LIST,
        payload: {
          page,
          limit: rowsPerPage,
        },
      });
    },
    [dispatch, rowsPerPage, page]
  );
  const getSettingDeclarationList = React.useCallback(
    (values) => {
      dispatch({
        type: SETTING_DECLARATIONS_LIST,
        payload: {
          page,
          limit: rowsPerPage
        },
      });
    },
    [dispatch, rowsPerPage, page]
  );

    const getSettingLockerList = React.useCallback(
    (values) => {
      dispatch({
        type: SETTING_LOCKER_LIST,
        payload: {
          page,
          limit: rowsPerPage
        },
      });
    },
    [dispatch, rowsPerPage, page]
  );

    const getShopperPriceList = React.useCallback(
    (values) => {
      dispatch({
        type: SHOPPER_PRICE_LIST,
        payload: {
          page,
          limit: rowsPerPage
        },
      });
    },
    [dispatch, rowsPerPage, page]
  );

  const getSettingNotificationList = React.useCallback(
    (values) => {
      dispatch({
        type: SETTING_NOTIFICATION_LIST,
        payload: {
          page,
          limit: rowsPerPage
        },
      });
    },
    [dispatch, rowsPerPage, page]
  );

  useEffect(()=>{
    switch (selectedTab) {
      case 0:
        break;
      case 1:
        getShippingPartnerList();
        break;
      case 2:
        getSettingCouponList();
        break;
      case 3:
        getSettingDeclarationList();
        break;
      case 4:
        getSettingLockerList();
        break;
      case 5:
        getSettingNotificationList();
        break;
      case 6:
        getShopperPriceList();
        break;
      default:
        break;
    }
  },[selectedTab, getShippingPartnerList, getSettingCouponList, getSettingDeclarationList, getSettingNotificationList, getSettingLockerList, getShopperPriceList])

  const setEditRowRecord = (data) => {
  // console.log("test123",data)
    setEditRecord({...data, ...(data?.originalStatus && { 
      status: data?.originalStatus
    })});
    setIsEditMode(true);
    addRecordModelHideShow();
  }

  const setDeleteRowRecord = (data) => {
    setEditRecord(data);
    setIsEditMode(true);
  }

  return (
    <StyledWrapper>
      <StyledBoxTextInner>
        <StyledTypographyText>Settings & Configure Master Data</StyledTypographyText>
        <Box>
          {selectedTab !== 0 && (
          <CustomButton
            fontSize={theme.typography.small.fontSize}
            startIcon={<CreateShipmentSvg width={20} height={20} />}
            btntype="warning"
            btnLabel="Add +"
            onClick={addRecordModelHideShow}
          />
          )}
        </Box>
      </StyledBoxTextInner>

      <StyledOrdersContainer>
        <OrderTableHeader
          tabLabels={tabLabels}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          responsiveMode
        />
        {selectedTab === 0 && <InvoiceSettingsPanel />}
        {selectedTab === 1 && (
          <>
            {isLoading ? (
              <Loader size={80} />
            ) : (
              <>
                <CommonTable
                  columns={shippingPartnercolumns}
                  rows={sellingPartnerList || []}
                  selectedTab={selectedTab}
                  tabLabels={tabLabels}
                  setEditRecord={setEditRowRecord}
                  setDeleteRecord={setDeleteRowRecord}
                  getShippingPartnerList={getShippingPartnerList}
                  setDeleteConfirmOpen={setDeleteConfirmOpen}
                />
                <TablePagination
                  component="div"
                  count={shippingPartner.total}
                  page={page - 1}
                  onPageChange={(event, newPage) => setPage(newPage)}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={(event) => {
                    setRowsPerPage(parseInt(event.target.value, 10));
                    setPage(1);
                  }}
                  rowsPerPageOptions={[5, 10, 25, 50]}
                />
              </>
            )}
          </>
        )}
        {selectedTab === 2 && (
          <>
            {isLoading ? (
              <Loader size={80} />
            ) : (
              <>
                <CommonTable
                  columns={couponColumns}
                  rows={couponList || []}
                  selectedTab={selectedTab}
                  tabLabels={tabLabels}
                  setEditRecord={setEditRowRecord}
                  setDeleteRecord={setDeleteRowRecord}
                  getShippingPartnerList={getSettingCouponList}
                  setDeleteConfirmOpen={setDeleteConfirmOpen}
                />
                <TablePagination
                  component="div"
                  count={shippingPartner.total}
                  page={page - 1}
                  onPageChange={(event, newPage) => setPage(newPage)}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={(event) => {
                    setRowsPerPage(parseInt(event.target.value, 10));
                    setPage(1);
                  }}
                  rowsPerPageOptions={[5, 10, 25, 50]}
                />
              </>
            )}
          </>
        )}
        {selectedTab === 3 && (
          <>
            {isLoading ? (
              <Loader size={80} />
            ) : (
              <>
                <CommonTable
                  columns={declarationsColumns}
                  rows={declarationList || []}
                  selectedTab={selectedTab}
                  tabLabels={tabLabels}
                  setEditRecord={setEditRowRecord}
                  setDeleteRecord={setDeleteRowRecord}
                  getShippingPartnerList={getSettingDeclarationList}
                  setDeleteConfirmOpen={setDeleteConfirmOpen}
                />
                <TablePagination
                  component="div"
                  count={shippingPartner.total}
                  page={page-1}
                  onPageChange={(event, newPage) => setPage(newPage)}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={(event) => {
                    setRowsPerPage(parseInt(event.target.value, 10));
                    setPage(1);
                  }}
                  rowsPerPageOptions={[5, 10, 25, 50]}
                />
              </>
            )}
          </>
        )}
         {selectedTab === 4 && (
          <>
            {isLoading ? (
              <Loader size={80} />
            ) : (
              <>
                <CommonTable
                  columns={lockerColumns}
                  rows={lockerList || []}
                  selectedTab={selectedTab}
                  tabLabels={tabLabels}
                  setEditRecord={setEditRowRecord}
                  setDeleteRecord={setDeleteRowRecord}
                  getShippingPartnerList={getSettingLockerList}
                  setDeleteConfirmOpen={setDeleteConfirmOpen}
                />
                <TablePagination
                  component="div"
                  count={shippingPartner.total}
                  page={page-1}
                  onPageChange={(event, newPage) => setPage(newPage)}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={(event) => {
                    setRowsPerPage(parseInt(event.target.value, 10));
                    setPage(1);
                  }}
                  rowsPerPageOptions={[5, 10, 25, 50]}
                />
              </>
            )}
          </>
        )}
        {selectedTab === 5 && (
          <>
            {isLoading ? (
              <Loader size={80} />
            ) : (
              <>
                <CommonTable
                  columns={notificationColumns}
                  rows={notificationList || []}
                  selectedTab={selectedTab}
                  tabLabels={tabLabels}
                  setEditRecord={setEditRowRecord}
                  setDeleteRecord={setDeleteRowRecord}
                  getShippingPartnerList={getSettingNotificationList}
                  setDeleteConfirmOpen={setDeleteConfirmOpen}
                />
                <TablePagination
                  component="div"
                  count={shippingPartner.total}
                  page={page-1}
                  onPageChange={(event, newPage) => setPage(newPage)}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={(event) => {
                    setRowsPerPage(parseInt(event.target.value, 10));
                    setPage(1);
                  }}
                  rowsPerPageOptions={[5, 10, 25, 50]}
                />
              </>
            )}
          </>
        )}

        {selectedTab === 6 && (
          <>
            {isLoading ? (
              <Loader size={80} />
            ) : (
              <>
                <CommonTable
                  columns={shopperPricingColumns}
                  rows={shopperPriceList || []}
                  selectedTab={selectedTab}
                  tabLabels={tabLabels}
                  setEditRecord={setEditRowRecord}
                  setDeleteRecord={setDeleteRowRecord}
                  getShippingPartnerList={getShopperPriceList}
                  setDeleteConfirmOpen={setDeleteConfirmOpen}
                />
                <TablePagination
                  component="div"
                  count={shippingPartner.total}
                  page={page - 1}
                  onPageChange={(event, newPage) => setPage(newPage)}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={(event) => {
                    setRowsPerPage(parseInt(event.target.value, 10));
                    setPage(1);
                  }}
                  rowsPerPageOptions={[5, 10, 25, 50]}
                />
              </>
            )}
          </>
        )}

      </StyledOrdersContainer>
      {shippingPartnerModel && (
        <ShippingPartners
          isEditMode={isEditMode}
          editRecord={editRecord}
          open={shippingPartnerModel}
          handleOpen={addRecordModelHideShow}
          handleClose={()=>{
            setIsEditMode(false)
            setEditRecord({})
            addRecordModelHideShow()
          }}
        />
      )}
      {couponModel && (
        <SettingCoupon
          isEditMode={isEditMode}
          editRecord={editRecord}
          open={couponModel}
          handleOpen={addRecordModelHideShow}
          handleClose={()=>{
            setIsEditMode(false)
            setEditRecord({})
            addRecordModelHideShow()
          }}
        />
      )}
      {declarationsModel && (
        <SettingDeclarations    
          isEditMode={isEditMode}
          editRecord={editRecord}
          open={declarationsModel}
          handleOpen={addRecordModelHideShow}
          handleClose={()=>{
            setIsEditMode(false)
            setEditRecord({})
            addRecordModelHideShow()
          }}
        />
      )}
      {notificationModel && (
        <SettingNotification    
          isEditMode={isEditMode}
          editRecord={editRecord}
          open={notificationModel}
          handleOpen={addRecordModelHideShow}
          handleClose={()=>{
            setIsEditMode(false)
            setEditRecord({})
            addRecordModelHideShow()
          }}
        />
      )}
      {lockerItemsModel && (
        <SettingLocker    
          isEditMode={isEditMode}
          editRecord={editRecord}
          open={lockerItemsModel}
          handleOpen={addRecordModelHideShow}
          handleClose={()=>{
            setIsEditMode(false)
            setEditRecord({})
            addRecordModelHideShow()
          }}
        />
            )}
             {shopperPriceItemsModel && (
           <SettingShopperPrice    
            isEditMode={isEditMode}
            editRecord={editRecord}
            open={shopperPriceItemsModel}
            handleOpen={addRecordModelHideShow}
            handleClose={()=>{
              setIsEditMode(false)
              setEditRecord({})
              addRecordModelHideShow()
              }}
            />
            )}

      {/* Delete Confirmation Modal */}
      <Confirmation
        open={deleteConfirmOpen}
        handleClose={() => setDeleteConfirmOpen(false)}
        heading="Delete !!"
        message="Are you sure you want to delete this record?"
        confirmButtonLabel="Delete"
        type="delete"
        onConfirm={deleteRecodConfirm}
      />
    </StyledWrapper>
  );
};

export default AdminSettings;
